import { useNavigate, useParams } from "react-router-dom";
import { Modal, Button, Dropdown } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheckAdmin/page";
import Header_ from "../compoenents/Header_";
import { AppValues, API, ApiAdmin, MAPS_API_KEY } from "../../Values";
import { useState, useMemo, useEffect, useRef } from "react";
import {
  GoogleMap,
  Marker,
  LoadScript,
  InfoWindow,
  OverlayView,
} from "@react-google-maps/api";

const mapContainerStyle = {
  width: "100%",
  height: "80%",
};

const center_ = {
  lat: 30.033,
  lng: 31.233,
};

export default function DellerNavigation() {
  const navigate = useNavigate();
  const params = useParams();
  const [map, setMap] = useState(null);
  const [center, Setcenter] = useState(center_);
  const [DellerInfo, SetDellerInfo] = useState([{ Name: "", locationName: "" }]);
  const [selectedDellerId, setSelectedDellerId] = useState(null);
  const [selectedLocationName, setSelectedLocationName] = useState("");
  const fetchIntervalRef = useRef(null);

  const libraries = useMemo(() => ["places", "geometry"], []);
  const [isLoaded, setIsLoaded] = useState(false);

  LoginCheck();

  const admininfo = Cookies.get("admininfo")
    ? JSON.parse(Cookies.get("admininfo"))
    : [];
  const AdminID = admininfo.length ? admininfo[0].ID : "";

  const [MAPS_API_KEY_, SET_MAPS_API_KEY] = useState(MAPS_API_KEY);

  useEffect(() => {
    GetApiKey();
  }, []);

  async function GetApiKey() {
    try {
      const type = "Google Maps";
      const post = {
        type: type,
        Action: "GetApiType",
      };
      const response = await fetch(ApiAdmin + "/Api_Setting.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      SET_MAPS_API_KEY(data[0].token);
    } catch (error) {
      return error;
    }
  }

  useEffect(() => {
    GetDeller();
  }, [params.DellerID]);

  useEffect(() => {
    fetchIntervalRef.current = setInterval(() => {
      GetData();
    }, 5000);

    return () => clearInterval(fetchIntervalRef.current);
  }, [center]);

  async function GetDeller() {
    try {
      const post = {
        ID: params.DellerID,
        Action: "AdminDellers",
      };
      const response = await fetch(ApiAdmin + "/deller.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();

      const newLatitude = parseFloat(data[0].latitude);
      const newLongitude = parseFloat(data[0].longitude);

      if (newLatitude !== center.lat || newLongitude !== center.lng) {
        SetDellerInfo(data);
        Setcenter({
          lat: newLatitude,
          lng: newLongitude,
        });
        smoothPanTo(newLatitude, newLongitude);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const [Data, SetData] = useState([]);

  async function GetData() {
    try {
      const post = {
        Action: "AdminDellers",
        SearchText: "",
      };
      const response = await fetch(ApiAdmin + "/deller.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data_ = await response.json();

      const datanew = JSON.stringify(data_);
      const dataold = JSON.stringify(Data);
      if (datanew !== dataold) {
        SetData(data_);
        smoothPanTo(center);
      }
    } catch (error) {
      return error;
    }
  }

  const smoothPanTo = (newLat, newLng) => {
    if (!map) return;

    const duration = 2000;
    const startLat = center.lat;
    const startLng = center.lng;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const currentLat = startLat + (newLat - startLat) * progress;
      const currentLng = startLng + (newLng - startLng) * progress;

      map.panTo({ lat: currentLat, lng: currentLng });

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        Setcenter({ lat: newLat, lng: newLng });
      }
    };

    requestAnimationFrame(animate);
  };

  const handleLoad = () => {
    setIsLoaded(true);
  };

  return (
    <>
      <Header_ />
      <div dir="rtl" className="row mt-0 text-center0 m-auto ">
        <div className="col-12 p-0 text-center bg-white">
          <h3 className="text-orange fw-bold py-1">تتبع المندوبين </h3>
        </div>
        <div className="col-master col-12 mt-0 bg-light px-1 text-center">
          <LoadScript
            googleMapsApiKey={MAPS_API_KEY_}
            libraries={libraries}
            onLoad={handleLoad}
          >
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              center={center}
              zoom={14}
              onLoad={(mapInstance) => {
                setMap(mapInstance);
              }}
              onDragEnd={() => {
                const center_ = map.getCenter();
                Setcenter({
                  lat: center_.lat(),
                  lng: center_.lng(),
                });
              }}
            >
              {Data.length > 0 &&
                Data.map((x, index) => {
                  if (!x.latitude || !x.longitude) return null;
                  const position = {
                    lat: parseFloat(x.latitude),
                    lng: parseFloat(x.longitude),
                  };
                  const isSelected = x.ID === selectedDellerId;

                  return (
                    <Marker key={index} position={position}>
                      <OverlayView
                        position={position}
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                      >
                        <div
                          onClick={() => {
                            setSelectedDellerId(x.ID);
                            setSelectedLocationName(x.locationName);
                          }}
                          style={{
                            backgroundColor: "#EA4335",
                            color: "white",
                            padding: "5px",
                            borderRadius: "5px",
                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
                            whiteSpace: "nowrap",
                            transform: "translate(50%, 10%)",
                            position: "absolute",
                            zIndex: "1000",
                            border: "1px solid #9C3A24",
                            cursor: "pointer",
                          }}
                        >
                          <span
                            className="fw-bold"
                            style={{ fontSize: "12px", color: "#ffffff" }}
                          >
                            {x.Name}
                          </span>
                        </div>
                      </OverlayView>

                      {isSelected && (
                        <InfoWindow
                          position={position}
                          onCloseClick={() => setSelectedDellerId(null)}
                        >
                          <div style={{ minWidth: "150px" }}>
                            <strong>{x.Name}</strong>
                            <br />
                            <small style={{ color: "#555" }}>
                              {selectedLocationName}
                            </small>
                          </div>
                        </InfoWindow>
                      )}
                    </Marker>
                  );
                })}
            </GoogleMap>
          </LoadScript>
          <br />
        </div>
      </div>
    </>
  );
}
